import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-white rounded-2xl px-4 py-8 mt-4" }
const _hoisted_2 = { class: "flex justify-start items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Payment Methods", -1)
const _hoisted_4 = { class: "pl-2" }
const _hoisted_5 = { class: "pt-2 flex justify-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 4v16m8-8H4"
  })
], -1)
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_9 = { class: "flex flex-row items-center justify-between w-full" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  class: "text-gray-500 mt-2 text-sm w-full"
}
const _hoisted_12 = {
  key: 1,
  class: "text-gray-500 mt-2 text-xs"
}
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_14 = { class: "flex flex-row items-center justify-between w-full" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "font-semibold capitalize text-sm" }
const _hoisted_17 = { class: "text-gray-500 mt-2 text-sm w-full" }
const _hoisted_18 = { class: "text-gray-500 mt-2 text-xs" }
const _hoisted_19 = { class: "flex flex-row items-center justify-between space-x-3" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-red-500",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
  })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-green-400",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Tooltip, { message: "Info for your payment methods" })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        onOnClick: _ctx.addCard,
        sizeLabel: "text-sm",
        label: "Add payment method",
        variant: ""
      }, {
        startIcon: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onOnClick"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (card, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex flex-row items-center justify-between bg-background-secondary rounded p-4 mt-8"
            }, [
              (card.card)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("img", {
                        src: _ctx.buildLogo(card.card.brand),
                        class: "w-8 h-8"
                      }, null, 8, _hoisted_10),
                      _createElementVNode("span", {
                        class: _normalizeClass(["font-semibold capitalize text-sm", card.type === 'ach' && 'pl-10'])
                      }, _toDisplayString(card.card.funding) + " " + _toDisplayString(card.type !== "ach" ? card.type : ""), 3)
                    ]),
                    (card.type !== 'ach')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "**** **** **** " + _toDisplayString(card.card.last4), 1))
                      : _createCommentVNode("", true),
                    (card.billing_details.name)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(card.billing_details.name), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (card.us_bank_account)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("img", {
                        src: _ctx.buildLogo('us_bank_account'),
                        class: "w-8 h-8"
                      }, null, 8, _hoisted_15),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(card.us_bank_account.bank_name) + " " + _toDisplayString(card.us_bank_account.account_type), 1)
                    ]),
                    _createElementVNode("span", _hoisted_17, " ********" + _toDisplayString(card.us_bank_account.last4), 1),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(card.us_bank_account.routing_number), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.removeCard(card)),
                  class: "hover:bg-gray-100"
                }, _hoisted_22, 8, _hoisted_20),
                (_ctx.defaultPaymentMethod === card.id || card?.default)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.setDefaultCard(card)),
                      class: "hover:bg-gray-100"
                    }, _hoisted_28, 8, _hoisted_26))
              ])
            ]))
          }), 128))
        ]))
  ]))
}